import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../../components/Rodal/Rodal';
import { LoiSubmissionPackage } from '../../../Admin/BuyerMarketplace/OpportunityDetails/LoiSubmissionPackage/LoiSubmissionPackage';

interface LoiSubmissionInformationPopupProps {
    loiFormId: string;
    engagementId: number;
    onClose: () => void;
}

const LoiSubmissionInformationPopup = (props: LoiSubmissionInformationPopupProps) => {
    return (
        <Rodal
            visible={true}
            onClose={props.onClose}
            animation="slideUp"
            showMask={true}
            width={1000}
            showCloseButton={true}
            customStyles={{ height: 'auto' }}>
            <ModalHeader>LOI Submission Information</ModalHeader>
            <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                <LoiSubmissionPackage
                    loiFormId={props.loiFormId}
                    isReadonly={true}
                    engagementId={props.engagementId}
                    canSubmit={false}
                    isLoiTabTermsOnly={true}
                />
            </ModalBody>
        </Rodal>
    );
};

export default LoiSubmissionInformationPopup;
